import { AfterViewInit, Component, signal, WritableSignal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { BaseComponent } from '../shared/base.component';
import { SiteHeaderComponent } from '../site-header/site-header.component';

@Component({
    selector: 'app-unknown-user',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        RouterLink,
        SiteHeaderComponent
    ],
    templateUrl: './unknown-user.component.html',
    styleUrl: './unknown-user.component.css'
})

export class UnknownAccountComponent extends BaseComponent implements AfterViewInit{

    private _email: WritableSignal<string> = signal<string>("");

    public ngAfterViewInit() {
        this._email.set(this.stateManager.getUserAccount().email);
    }

    protected get email(): string {
        return this._email();
    }
}
